module.exports = __webpack_public_path__ + "img/JunNishimura_企画書_ページ_06.c247779a.jpg";